module.exports = __webpack_public_path__ + "img/stock6.61ff8932.png";